export default function NoticeCard({
  title,
  shortDescription,
  url,
  buttonText = "Click Here",
}) {
  return (
<div className="mb-4 border-bottom hover-shadow p-4 d-flex flex-column flex-md-row justify-content-between align-items-md-center bg-primary">      
      {/* LEFT SIDE */}
      <div className="pr-3">
        <h4 className="mb-1">{title.toUpperCase()}</h4>
        <p className="mb-0">{shortDescription}</p>
      </div>

      {/* RIGHT SIDE */}
      {url && (
        <div className="mt-3 mt-md-0 ml-md-3 flex-shrink-0">
          <a href={`${url}`} className="btn btn-secondary">
            {buttonText}
          </a>
        </div>
      )}

    </div>
  );
}